import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "@/app/App";
import { AppProviders } from "@/app/AppProviders";
import "@/styles/index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("The #root element is missing from index.html.");

const application = (
  <StrictMode>
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </StrictMode>
);

if (rootElement.querySelector("*")) hydrateRoot(rootElement, application);
else createRoot(rootElement).render(application);
